import { authClient } from "@/api/http-client"
import {IFilterValues, IMessage, IPaginatedCollection, IPaginationRequest} from "@/api/types"
import { IPolicyWithBalanceInfo, ILoginUrl } from "@/types/policy"

export function login (id: number) {
    // return authClient
    //     .post<IToken>(`policy/{id}/login`)
        // .then((resp) => resp.data)
}

export function fetchAll(pagination: IPaginationRequest, filterValues: IFilterValues): Promise<IPaginatedCollection<IPolicyWithBalanceInfo>> {
  return authClient
    .get<IPaginatedCollection<IPolicyWithBalanceInfo>>(`policy`, {
      params: { ...pagination, filter: filterValues }
    })
    .then((resp) => resp.data)
}

export function loginUrl(id: number): Promise<ILoginUrl> {
  return authClient
    .post<ILoginUrl>(`policy/${id}/login`)
    .then((resp) => resp.data)
}

export function sendToEmail(): Promise<IMessage> {
  return authClient
    .post<IMessage>(`policy/export`)
    .then((resp) => resp.data)
}

export default {
  fetchAll,
  loginUrl,
  sendToEmail
}